import { PostAPI } from 'Components/Helper/Helpers';

export const Add = async (request) => {
    return PostAPI(request, 'OutsideRegistration/Insert');
};

export const SelectState = async (request) => {
    return PostAPI(request, 'OutsideRegistration/SelectState');
};

export const SelectRole = async (request) => {
    return PostAPI(request, 'OutsideRegistration/SelectRoleForOutside');
};

export const SelectPlayStoreURL = async (request) => {
    return PostAPI(request, 'OutsideRegistration/SelectPlayStoreURL');
};

export const SelectRoleForSignUp = async (request) => {
    return PostAPI(request, 'OutsideRegistration/SelectRoleForSignUp');
};

export const SignUpSendOTP = async (request) => {
    return PostAPI(request, 'OutsideRegistration/SignUpGenerateOTP');
};

export const VerifySignUpOTP = async (request) => {
    return PostAPI(request, 'OutsideRegistration/VerifySignUpOTP');
};
